import React from 'react'

import Checkbox from '../Fields/Checkbox'
import SingleInput from '../Fields/SingleInput'
import TextArea from '../Fields/TextArea'

import content from '../../assets/content/OrthognathicSurgery.json'

const ModuleSix = (props) => {
	return (
		<ol>
			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox1"}
					id={"initial"}
					value={props.consentForm.cBox1.initial}
				/>I hereby authorize Dr.
				<SingleInput
					name={"cBox1"}
					controlFunc={props.addToForm}
					inputType={"text"}
					id={"docName"}
					value={props.consentForm.cBox1.docName}
				/>and staff to treat the condition as described as:
				<TextArea
					name={"cBox1"}
					controlFunc={props.addToForm}
					inputType={"text"}
					id={"description"}
					value={props.consentForm.cBox1.description}
				/>
			</li>
			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox2"}
					id={"initial"}
					value={props.consentForm.cBox2.initial}
				/>
				The surgical procedure planned to treat the above condition has been explained to me, and I understand the nature of the treatment to be:
				<TextArea
					controlFunc={props.addToForm}
					inputType={"text"}
					name={"cBox2"}
					id={"description"}
					value={props.consentForm.cBox2.description}
				/>
			</li>
			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox3"}
					id={"initial"}
					value={props.consentForm.cBox3.initial}
				/>
				I have been informed of possible alternative forms of treatment (if any), including:
				<TextArea
					controlFunc={props.addToForm}
					inputType={"text"}
					name={"cBox3"}
					id={"description"}
					value={props.consentForm.cBox3.description}
				/>
			</li>
			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox4"}
					value={props.consentForm.cBox4}
				/>
				My doctor has explained to me that there are certain potential risks and side effects of my surgery, some of which may be serious. They include, but are not limited to:
				<ol type="A">
					{content.map((item, index) => {
						let itemNumber = index + 1
						return (
							<li key={index}>
								<Checkbox
									controlFunc={props.addToForm}
									id={itemNumber}
									name={"cBox4Risks"}
									value={props.consentForm.cBox4Risks[itemNumber]}
								/>{item}
							</li>
						)
					})}
				</ol>
			</li>
			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox5"}
					value={props.consentForm.cBox5}
				/>General anesthesia will be used for this surgery and I have been told of the risks, including bronchitis, pneumonia, hoarseness or voice changes, cardiac irregularities, heart attack or death. I am aware of the importance of not having anything by mouth (including clear liquids unless specifically authorized by my doctor or anesthesiologist) <u>FOR <strong>EIGHT (8) HOURS </strong>PRIOR TO MY ANESTETIC. <strong>TO DO OTHERWISE MAY BE LIFE-THREATENING!</strong></u>
			</li>

			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox6"}
					value={props.consentForm.cBox6}
				/>I realize the importance of providing true and accurate information about my health, especially concerning possible pregnancy, allergies, medications and history of drug or alcohol use. If I misinform my doctor I understand the consequences may be life-threatening or otherwise adversely affect the results of my surgery.
			</li>
			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox7"}
					value={props.consentForm.cBox7}
				/>If my teeth are wired together after this surgery, I understand there are certain associated risks and complications: oral hygiene will be diminished, there may be resulting gum disease, my teeth will feel slightly loose for some time after the wiring, and there is always some concern about airway obstruction. I agree to carry wire cutters with me at all times when my jaws are wired and to avoid the use of alcohol and other activities tht may cause nausea or airway problems.
			</li>
		</ol>
	)
}

export default ModuleSix


// WEBPACK FOOTER //
// ./src/components/Modules/6.js